<template>
  <el-select
    trigger="click"
    size="medium"
    :value="selectedOrg ? selectedOrg.id : null"
    class="mr-m"
    @change="handleSelectOrg"
  >
    <el-option
      v-for="org in allOrganizations"
      :key="org.id"
      :value="org.id"
      :label="org.summary"
    />
  </el-select>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SelectOrg",
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters("organization", ["allOrganizations", "selectedOrg"]),
  },
  watch: {
    allOrganizations: "initData"
  },
  beforeMount() {
    this.initData();
  },
  methods: {
    ...mapActions("organization", ["setSelectedOrg"]),
    initData() {
      if (!this.selectedOrg && this.allOrganizations.length > 0) {
        const org = this.allOrganizations[0];
        this.setSelectedOrg(org);
      } else {
        this.setSelectedOrg(this.selectedOrg);
      }
    },
    handleSelectOrg(orgId) {
      const org = this.allOrganizations.find((o) => o.id === orgId);
      this.setSelectedOrg(org);
    },
  },
};
</script>

<style lang="scss"></style>
